import { IframelyContext, Theme } from "@equiem/web-ng-lib";
import React, { useContext, useEffect } from "react";
import { useLinktype } from "../hooks/useLinkType";
import { useViewerTokens } from "../hooks/useViewerTokens";

interface Props {
  html: string;
  className?: string;
  id?: string;
}

const targetBlankExternalLinks = (
  containerId: string,
  isExternalLink: (_link: string) => boolean,
) => {
  const links = document.getElementById(containerId)?.getElementsByTagName("a");
  if (links == null) {
    return;
  }

  const internal = new RegExp(location.host.replace("www.", ""), "i");
  // tslint:disable-next-line: prefer-for-of
  for (let i = 0; i < links.length; i++) {
    // Avoid mailto, javascript or empty.
    if (
      links[i].href.match(/^mailto\:/) ||
      links[i].href.match(/^javascript\:/) ||
      links[i].href.match(/^$/)
    ) {
      continue;
    }

    // Make sure the href doesn't contain current site's host.
    const href = links[i].host;
    if (internal.test(href)) {
      continue;
    }

    if (!isExternalLink(links[i].href)) {
      return;
    }

    links[i].setAttribute("target", "_blank");
    links[i].setAttribute("rel", "noopener noreferrer");
  }
}

export const PostContent: React.FC<Props> = ({ html, id = "post-content", className = "" }) => {
  const viewerTokens = useViewerTokens();
  const iframely = useContext(IframelyContext);
  const theme = useContext(Theme);
  const { isExternalLink } = useLinktype()

  useEffect(() => {
    iframely.load();

    targetBlankExternalLinks(id, isExternalLink);
  }, []);

  return (
    <div id={id} className={`post-content ${className}`}>
      <div dangerouslySetInnerHTML={{ __html: viewerTokens(html) }}></div>
      <style jsx>{`
      .post-content :global(img) {
        max-width: 100%;
      }
      .post-content {
        line-height: 1.7;
      }
      .post-content :global(a) {
        color: ${theme.colors.defaultLink}
      }
    `}</style>
    </div>
  );
}
